define('CheckoutDocumentUpload.View', [
    'Wizard.StepModule',
    'CheckoutDocumentUpload.Model',
    'snapshot_checkoutdocumentupload.tpl',
    'underscore',
    'jQuery'
], function (
    WizardStepModule,
    CheckoutDocumentUploadModel,
    checkoutDocumentUploadTpl,
    _,
    jQuery
) {
    'use strict';

    var StepModule = WizardStepModule['__esModule'] ? WizardStepModule['WizardStepModule'] : WizardStepModule;

    var MAX_FILE_SIZE    = 10 * 1024 * 1024; // 10 MB
    var ALLOWED_EXT      = ['pdf'];
    var ALLOWED_MIME     = ['application/pdf'];

    return StepModule.extend({

        template: checkoutDocumentUploadTpl,

        events: {
            'change #document-upload-input': 'onFilesSelected',
            'click .document-upload-remove':  'removeFile'
        },

        initialize: function (options) {
            StepModule.prototype.initialize.apply(this, arguments);
            this.fileQueue       = []; // [{ id, fileName, fileSize, file, status, fileId, error }]
            this._uploading      = false;
            this._idCounter      = 0;
        },

        getContext: function () {
            var queue = _.map(this.fileQueue, function (item) {
                return {
                    id:         item.id,
                    fileName:   item.fileName,
                    fileSize:   item.fileSize,
                    isPending:  item.status === 'pending',
                    isUploading: item.status === 'uploading',
                    isDone:     item.status === 'done',
                    isError:    item.status === 'error',
                    canRemove:  item.status === 'done' || item.status === 'error',
                    error:      item.error || ''
                };
            });

            return {
                fileQueue:   queue,
                hasFiles:    queue.length > 0,
                isUploading: this._uploading
            };
        },

        // ─── File selection ────────────────────────────────────────────────

        onFilesSelected: function (e) {
            var files = e.target.files;
            if (!files || !files.length) { return; }

            for (var i = 0; i < files.length; i++) {
                this._enqueue(files[i]);
            }

            // Reset so the same filename can be re-selected after an error
            e.target.value = '';

            this._processQueue();
        },

        _enqueue: function (file) {
            var ext = file.name.split('.').pop().toLowerCase();

            if (ALLOWED_EXT.indexOf(ext) === -1) {
                this._addItem(file.name, null, 'error', 'Only PDF files are accepted.');
                return;
            }

            if (file.size > MAX_FILE_SIZE) {
                this._addItem(file.name, null, 'error', 'File exceeds the 10 MB limit.');
                return;
            }

            this._addItem(file.name, file, 'pending', null);
        },

        _addItem: function (fileName, fileObj, status, error) {
            this._idCounter++;
            this.fileQueue.push({
                id:       'doc-' + this._idCounter,
                fileName: fileName,
                fileSize: fileObj ? this._formatSize(fileObj.size) : '',
                file:     fileObj,
                status:   status,
                fileId:   null,
                error:    error
            });
            this.render();
        },

        // ─── Upload queue ──────────────────────────────────────────────────

        _processQueue: function () {
            if (this._uploading) { return; }

            var next = _.find(this.fileQueue, function (item) {
                return item.status === 'pending';
            });

            if (next) { this._uploadItem(next); }
        },

        _uploadItem: function (item) {
            var self    = this;
            var reader  = new FileReader();

            this._uploading  = true;
            item.status      = 'uploading';
            this.render();

            reader.onload = function (e) {
                var raw  = e.target.result;
                var b64  = raw.indexOf(',') > -1 ? raw.split(',')[1] : raw;
                var uploadModel = new CheckoutDocumentUploadModel();

                uploadModel.save({
                    fileName:    item.fileName,
                    fileContent: b64,
                    mimeType:    item.file ? (item.file.type || 'application/pdf') : 'application/pdf'
                }).done(function (resp) {
                    self._uploading = false;
                    item.file       = null;

                    if (resp && resp.fileId) {
                        item.status = 'done';
                        item.fileId = resp.fileId;
                        self._persistFile(resp.fileId, item.fileName);
                    } else {
                        item.status = 'error';
                        item.error  = (resp && resp.error) || 'Upload failed. Please try again.';
                    }

                    self.render();
                    self._processQueue();
                }).fail(function (jqXhr) {
                    self._uploading = false;
                    item.file       = null;
                    item.status     = 'error';

                    try {
                        var parsed = JSON.parse(jqXhr.responseText);
                        item.error = (parsed && parsed.error) || 'Upload failed. Please try again.';
                    } catch (ex) {
                        item.error = 'Upload failed. Please try again.';
                    }

                    self.render();
                    self._processQueue();
                });
            };

            reader.onerror = function () {
                self._uploading = false;
                item.file       = null;
                item.status     = 'error';
                item.error      = 'Could not read the file. Please try again.';
                self.render();
                self._processQueue();
            };

            reader.readAsDataURL(item.file);
        },

        // ─── Sync uploaded file IDs to the order options field ───────────────

        _syncFileIds: function () {
            if (!this.model) { return; }
            var options  = _.extend({}, this.model.get('options') || {});
            var existing = _.filter((options.custbody_ssd_file_attachment_ids || '').split(','), function (id) { return !!id; });

            _.chain(this.fileQueue)
                .filter(function (item) { return item.status === 'done' && item.fileId; })
                .pluck('fileId')
                .map(String)
                .each(function (id) {
                    if (existing.indexOf(id) === -1) { existing.push(id); }
                });

            options.custbody_ssd_file_attachment_ids = existing.join(',');
            this.model.set('options', options);
        },

        _persistFile: function (fileId, fileName) {
            if (!this.model) { return; }
            var files = (this.model.get('__documentFiles') || []).concat([{ fileId: fileId, fileName: fileName }]);
            this.model.set('__documentFiles', files, { silent: true });
            this._syncFileIds();
        },

        // ─── Remove a queued / completed item ─────────────────────────────

        removeFile: function (e) {
            var id   = jQuery(e.currentTarget).data('id');
            var item = _.findWhere(this.fileQueue, { id: id });

            if (item && item.status === 'done' && item.fileId && this.model) {
                var fileIdStr = String(item.fileId);

                this.model.set('__documentFiles', _.reject(this.model.get('__documentFiles') || [], function (f) {
                    return f.fileId === item.fileId;
                }), { silent: true });

                var options  = _.extend({}, this.model.get('options') || {});
                var filtered = _.filter((options.custbody_ssd_file_attachment_ids || '').split(','), function (id) {
                    return !!id && id !== fileIdStr;
                });
                options.custbody_ssd_file_attachment_ids = filtered.join(',');
                this.model.set('options', options);
            }

            this.fileQueue = _.reject(this.fileQueue, function (i) { return i.id === id; });
            this.render();
        },

        // ─── Wizard interface ──────────────────────────────────────────────

        // Block the step advance if anything is still uploading
        submit: function () {
            var busy = _.find(this.fileQueue, function (item) {
                return item.status === 'pending' || item.status === 'uploading';
            });

            if (busy) {
                var d = jQuery.Deferred();
                d.reject({ errorMessage: 'Please wait for all files to finish uploading before continuing.' });
                return d;
            }

            return jQuery.Deferred().resolve();
        },

        isActive: function () { return true; },

        // ─── Helpers ──────────────────────────────────────────────────────

        _formatSize: function (bytes) {
            if (bytes < 1024)    { return bytes + ' B'; }
            if (bytes < 1048576) { return Math.round(bytes / 1024) + ' KB'; }
            return (bytes / 1048576).toFixed(1) + ' MB';
        }

    });
});
